module.exports = __webpack_public_path__ + "static/img/Send4.6a2f18d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send4.png
// module id = ogNH
// module chunks = 0